// src/pages/PopupContent.jsx
import React from 'react';

export default function PopupContent({ data }) {
  // data: { courierId, latitude, longitude, recordedAt, routeListId }
  return (
    <div style={{ minWidth: '150px' }}>
      <h4>Курьер {data.courierId}</h4>
      <p><strong>Маршрут:</strong> {data.routeListId || '—'}</p>
      <p><strong>Время:</strong> {new Date(data.recordedAt).toLocaleString()}</p>
      <p><strong>Коорд.:</strong> {data.latitude.toFixed(5)}, {data.longitude.toFixed(5)}</p>
    </div>
  );
}
